import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ICandidate } from "./models/candidates";

@Injectable({
  providedIn: "root"
})
export class CandidateService {
  public list: any = [];
  public baseUrl: string = "/candidate";

  constructor(private _httpClient: HttpClient) {
  }

  async getCandidatesList() {
    return this._httpClient.get<ICandidate[]>(`${this.baseUrl}`).toPromise();
  }

  async getCandidate(user_hash: string) {
    return this._httpClient.get(`${this.baseUrl}/${user_hash}`).toPromise();
  }

  async createCandidate(data: any = {}) {
    return this._httpClient.post(`${this.baseUrl}`, data).toPromise();
  }

  async updateCandidate(user_hash: string, data: any = {}) {
    return this._httpClient.put(`${this.baseUrl}/${user_hash}`, data).toPromise();
  }

  async deleteCandidate(user_hash: string) {
    return this._httpClient.delete(`${this.baseUrl}/${user_hash}`).toPromise();
  }

  async requestMasterData(hash: string) {
    return this._httpClient.get(`/candidate/${hash}/request-masterdata`).toPromise();
  }

  async requestSignContract(hash: string) {
    return this._httpClient.get(`/candidate/${hash}/request-sign-contract`).toPromise();
  }

  async updateCandidateLanding(data: any = {}) {
    return this._httpClient.post(`/candidate/send-masterdata`, data).toPromise();
  }

  async getCandidateMatchRequest(user_hash: string) {
    return this._httpClient.get(`/request/reverse-match/${user_hash}`).toPromise();
  }

  async getHiredCandidates(year: number) {
    return this._httpClient.get(`/hired-candidates/${year}`).toPromise();
  }

  async editCandidateNote(note_id: number, data: { note: string }) {
    return this._httpClient.put(`/candidate/note/${note_id}`, data).toPromise();
  }

  async deleteCandidateNote(note_id: number) {
    return this._httpClient.delete(`/candidate/note/${note_id}`).toPromise();
  }
}
